import { PENDING_BUSINESS_ID } from './authentication.const';
export const FEATURE_FLAG_BUSINESS_GROUP = 'business';
export const FEATURE_FLAGS = {
    enableTiktok: {
        key: 'enable_tiktok',
        scope: 'user',
        fallback: true,
        description: 'TikTok in the platform lists and publish endpoints.',
    },
    enableYoutube: {
        key: 'enable_youtube',
        scope: 'user',
        fallback: true,
        description: 'YouTube Shorts in the platform lists and publish endpoints. On for everyone.',
    },
    enablePinterest: {
        key: 'enable_pinterest',
        scope: 'user',
        fallback: true,
        description: 'Pinterest in the platform lists and publish endpoints. On for everyone.',
    },
    enableX: {
        key: 'enable_x',
        scope: 'user',
        fallback: false,
        description: 'X (Twitter) in the platform lists and publish endpoints. Coming-soon platform, internal only.',
    },
    enableLinkedinOrg: {
        key: 'enable_linkedin_org',
        scope: 'user',
        fallback: true,
        description: 'LinkedIn Company Page connect chooser (linkedin vs linkedin_org OAuth app). On for everyone.',
    },
    engagementSection: {
        key: 'engagement_section',
        scope: 'business',
        fallback: false,
        description: 'Comment automation end to end: /engagement tab, sweep enqueue, reply/DM processor. Grandfathered businesses only; fails closed.',
    },
    analyticsSection: {
        key: 'analytics_section',
        scope: 'user',
        fallback: false,
        description: 'Social insights: calendar engagement feed and public API analytics read. Fans out to Meta/LinkedIn; off.',
    },
    referralProgram: {
        key: 'referral_program',
        scope: 'user',
        fallback: true,
        description: 'Referral program master switch: signup capture, UI, and non-prod payout eligibility. On in prod; @taka.ai in dev.',
    },
    creditUsageAnalytics: {
        key: 'credit_usage_analytics',
        scope: 'user',
        fallback: true,
        description: 'Credit usage analytics panel on the Billing page. On for everyone.',
    },
    onboardingConversationMobile: {
        key: 'onboarding_conversation_mobile',
        scope: 'user',
        fallback: false,
        description: 'Conversational first-business onboarding instead of the confirm form. Off.',
    },
    enableSocialFallback: {
        key: 'enable_social_fallback',
        scope: 'user',
        fallback: false,
        description: 'Partner-gateway (Phyllo) section in the Facebook page picker when our Meta app returns no Pages. Off.',
    },
    testerYearlyGrant: {
        key: 'tester_yearly_grant',
        scope: 'user',
        fallback: false,
        description: 'Onboarding paywall grants a free subscription to test+…@taka.ai accounts. Billing: never fail open.',
    },
    enableGmailSkill: {
        key: 'enable_gmail_skill',
        scope: 'user',
        fallback: false,
        description: 'Adds Gmail scopes to the legacy Google OAuth initiate. Nothing consumes Gmail; off.',
    },
    assetsCache: {
        key: 'assets_cache',
        scope: 'user',
        fallback: true,
        description: 'Reuse cached signed attachment URLs instead of signing per load (one IAM call per row otherwise). On.',
    },
    enableUnifiedDirectGateway: {
        key: 'enable_unified_direct_gateway',
        scope: 'user',
        fallback: false,
        description: 'Route direct connections through the unified DirectGateway instead of the legacy OAuth publish paths. Off.',
    },
    simulatePublish: {
        key: 'simulate_publish',
        scope: 'user',
        fallback: false,
        description: 'Dev/QA: "Post Now" fakes a successful publish. Off; per-browser override via localStorage simulate_publish=true.',
    },
    publicApiKillSwitch: {
        key: 'public_api_kill_switch',
        scope: 'user',
        fallback: false,
        description: 'EMERGENCY: enabling this kills the public API + MCP surface. Unresolvable reads as not killed (fail open).',
    },
};
export const BUSINESS_FEATURE_FLAGS = Object.values(FEATURE_FLAGS).filter((flag) => flag.scope === 'business');
export function flagBusinessId(businessId) {
    return businessId && businessId !== PENDING_BUSINESS_ID ? businessId : undefined;
}
//# sourceMappingURL=feature-flags.const.js.map